import { render, staticRenderFns } from "./index--detail.vue?vue&type=template&id=96e4722a&"
import script from "./index--detail.vue?vue&type=script&lang=js&"
export * from "./index--detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports